import { EType } from '../../repositories/newbuilding-promos/entities/json_query/IntTermFieldSchema';
import { IJsonQuerySchema } from '../../repositories/newbuilding-promos/entities/json_query/JsonQuerySchema';

export const getQsonJueryMk = (): IJsonQuerySchema => {
  return {
    isFromBank: {
      type: EType.Term,
      value: true,
    },
  };
};
